import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { IconsComponent } from '../icons/icons.component';
import { ButtonComponent } from '../button/button.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'vti-confirm',
  templateUrl: './confirm.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, IconsComponent, ButtonComponent],
})
export class ConfirmComponent {
  public onOkClick(): void {
    this.messageService.confirmAfterClose(true);
  }

  public onCancelClick(): void {
    this.messageService.confirmAfterClose(false);
  }

  private readonly messageService = inject(MessageService);

  public visible = toSignal(this.messageService.confirmVisible$, { initialValue: false });
  public title = computed(() => this.messageService.vtiConfirm().title);
  public content = computed(() => this.messageService.vtiConfirm().content);
  public okText = computed(() => this.messageService.vtiConfirm().okText);
  public cancelText = computed(() => this.messageService.vtiConfirm().cancelText);
}
